var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aboutus-container"},[_c('module1'),_c('module2',{ref:"about2"}),_c('module3',{ref:"about3"}),_c('module4',{ref:"about4"}),_c('module5',{ref:"about5"}),_c('module6',{ref:"about6"}),_c('module7')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }